export default __webpack_public_path__ + "static/media/row2.91f8dc5d.svg";